
import Transfer from "../../../components/Modal/components/transfer-tab";
import { BucketDataType } from "../../../types/bucketTypes";

export default function TransferTab({ asset }: { readonly asset: BucketDataType }) {
    // Provide stub/placeholder props for Transfer component integration
    // You may want to connect these to actual logic as needed
    const fetchBucketList = async () => {};
    const setIsModalShown = () => {};
    const triggerToastMessage = () => {};
    // Guest logic: if no userData or roles is guest
    const StorageService = require("../../../services/storage_service");
    const ROLES = StorageService.ROLES;
    const Roles = require("../../../constants/roles.constants").Roles;

        const rolesRaw = StorageService.StorageService.getItem(ROLES);
        let isGuest = false;
        if (rolesRaw) {
            try {
                const parsed = JSON.parse(rolesRaw);
                if (Array.isArray(parsed)) {
                    isGuest = parsed.includes(Roles.GUEST);
                } else if (typeof parsed === "string") {
                    isGuest = parsed === Roles.GUEST;
                }
            } catch {
                isGuest = false;
            }
        }

    return (
        <div className='tab-body transfer-container'>
            <Transfer
                isGuest={isGuest}
                setIsModalShown={setIsModalShown}
                fetchBucketList={fetchBucketList}
                selectedAsset={asset}
                triggerToastMessage={triggerToastMessage}
            />
        </div>
    );
}
